import { channels } from "@swa-ui/application";

export const channelMapping = {
  corporate: {
    corporate: channels.corporate,
    leisure: channels.corporate,
    vacations: channels.corporate,
  },
  mobile: {
    corporate: channels.mwebCorp,
    leisure: channels.mweb,
    vacations: channels.mweb,
  },
  southwest: {
    corporate: channels.corporate,
    leisure: channels.southwest,
    vacations: channels.southwest,
  },
};
